//Components
import Faq from "../../components/Faq";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Navbar from "../../components/Navbar";
import Register from "../../components/Register";
import Schedule from "../../components/Schedule";
import Speakers from "../../components/Speakers";
import WhatIsBizzTrip from "../../components/WhatIsBizzTrip";
import WhoCanApply from "../../components/WhoCanApply";

const Main = (props) => {
  return (
    <>
      <Navbar
        currentLang={props.currentLang}
        setCurrentLang={props.setCurrentLang}
      />
      <Header
        currentLang={props.currentLang}
        setCurrentLang={props.setCurrentLang}
      />
      <div className="bg-[url(../../assets/images/what-is-bizztrip-bg.png)] bg-cover bg-top -mt-40 md:-mt-66 lg:-mt-80 pt-24 py-72 lg:py-72">
        <WhatIsBizzTrip
          currentLang={props.currentLang}
          setCurrentLang={props.setCurrentLang}
        />
        <WhoCanApply
          currentLang={props.currentLang}
          setCurrentLang={props.setCurrentLang}
        />
      </div>
      <Schedule
        currentLang={props.currentLang}
        setCurrentLang={props.setCurrentLang}
      />
      <Speakers
        currentLang={props.currentLang}
        setCurrentLang={props.setCurrentLang}
      />
      <Faq
        currentLang={props.currentLang}
        setCurrentLang={props.setCurrentLang}
      />
      <Register
        currentLang={props.currentLang}
        setCurrentLang={props.setCurrentLang}
      />
      <Footer
        currentLang={props.currentLang}
        setCurrentLang={props.setCurrentLang}
      />
    </>
  );
};

export default Main;
